module.exports = __webpack_public_path__ + "img/JT-7-4-1-19a-no3.f52f26bc.jpg";